export const toTradeNumber = (value) => {
  if (value == null || value === "") return null;
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }
  const cleaned = String(value).replace(/,/g, "").trim();
  if (!cleaned) return null;
  const num = Number(cleaned);
  return Number.isFinite(num) ? num : null;
};

export const inferTradeSide = (entry, stop, target) => {
  if (entry == null) return null;
  if (stop != null && stop !== entry) {
    return stop < entry ? "long" : "short";
  }
  if (target != null && target !== entry) {
    return target > entry ? "long" : "short";
  }
  return null;
};

export const overlayAppliesToTicker = (item, selectedTickerId) => {
  const itemTickerId = item?.ticker_id ?? item?.tickerId ?? null;
  if (itemTickerId == null || selectedTickerId == null) return true;
  return String(itemTickerId) === String(selectedTickerId);
};

export const colorWithAlpha = (color, alpha) => {
  const normalizedAlpha = Math.max(0, Math.min(Number(alpha) || 0, 1));
  const hexAlpha = Math.round(normalizedAlpha * 255).toString(16).padStart(2, "0");
  if (typeof color === "string" && /^#[0-9a-f]{6}$/i.test(color)) {
    return `${color}${hexAlpha}`;
  }
  const rgb = String(color || "").match(/^rgba?\(([^)]+)\)$/i);
  if (rgb) {
    const parts = rgb[1].split(",").slice(0, 3).map((part) => part.trim());
    return `rgba(${parts.join(", ")}, ${normalizedAlpha})`;
  }
  return `rgba(100, 116, 139, ${normalizedAlpha})`;
};
